import ClinicalAIAssistant from './ClinicalAIAssistant'

export default ClinicalAIAssistant
